const MONITOR_SCREEN_SCENE_CONFIG = {
  camera: {
    fov: 45,
    aspect: 16 / 9,
    near: 0.5,
    far: 40,
  },
  renderTarget: {
    width: 1200,
    height: 675,
  }
};

export default MONITOR_SCREEN_SCENE_CONFIG;
